import { msalConfig } from "../configs/msalConfig";
import {
	hasInternetConnection,
	loadFromLocalStorage,
	removeFromLocalStorage,
	removeFromSessionStorage,
	saveToLocalStorage,
} from "./systemService";
import {
	b2cToken,
	b2cEmail,
	dashToken,
	autoLoginToken,
	autoLogin,
	userSettingsKeys,
} from "../configs/storageKeys.json";
import * as dashApiService from "./dashApiService";
import CryptoJS from "crypto-js";

function logout(msalInstance, account) {
	const clearStorageAndB2C = () => {
		removeFromLocalStorage(dashToken);
		removeFromLocalStorage(b2cEmail);
		removeFromLocalStorage(b2cToken);
		removeFromLocalStorage(userSettingsKeys.pid);
		removeFromLocalStorage(userSettingsKeys.settings);
		removeFromLocalStorage(userSettingsKeys.startDate);
		removeFromSessionStorage(userSettingsKeys.isLoggedIn);
		handleB2CLogout(msalInstance, account);
	};

	const storedDashToken = loadDashToken();

	if (storedDashToken === null) {
		clearStorageAndB2C();
	} else {
		dashApiService
			.logout()
			.catch((error) => {
				console.error(
					"Error logging out from dash api, continuing logout",
					error
				);
			})
			.then(clearStorageAndB2C);
	}
}

function clearLocalStorage() {
	const _autoLoginToken = loadAutoLoginToken();
	const _autoLogin = loadAutoLogin();

	localStorage.clear();

	saveAutoLoginToken(_autoLoginToken);
	saveAutoLogin(_autoLogin);
}

function saveAutoLogin(token) {
	saveToLocalStorage(autoLogin, token.toString());
}

function saveAutoLoginToken(token) {
	saveToLocalStorage(autoLoginToken, token);
}

function saveB2CToken(token) {
	const encrypted = encrypt(token);
	saveToLocalStorage(b2cToken, encrypted);
}

function saveB2CEmail(email) {
	saveToLocalStorage(b2cEmail, email);
}

function saveDashToken(token) {
	const encryptedToken = encrypt(token);
	saveToLocalStorage(dashToken, encryptedToken);
}

function loadB2CToken() {
	const encrypted = loadFromLocalStorage(b2cToken);
	return decrypt(encrypted);
}

function loadB2CEmail() {
	return loadFromLocalStorage(b2cEmail);
}

function loadDashToken() {
	const encryptedToken = loadFromLocalStorage(dashToken);
	return decrypt(encryptedToken);
}

function loadAutoLoginToken() {
	const token = loadFromLocalStorage(autoLoginToken);
	return token;
}

function loadAutoLogin() {
	const token = loadFromLocalStorage(autoLogin);
	return token === "true";
}

function handleB2CLogout(msalInstance, account) {
	const logoutRequest = {
		account: account,
		postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
	};

	if (hasInternetConnection()) {
	} else {
		logoutRequest.onRedirectNavigate = (url) => {
			return false;
		};
	}

	msalInstance.logoutRedirect(logoutRequest);
}

function encrypt(token) {
	if (token) {
		const email = loadB2CEmail();
		if (email) {
			try {
				const result = CryptoJS.Rabbit.encrypt(token, email).toString();
				return result;
			} catch (error) {
				console.error("Error encrypting value", error);
			}
		} else {
			return token;
		}
	}
	return null;
}

function decrypt(encryptedText) {
	if (encryptedText) {
		const email = loadB2CEmail();
		if (email) {
			try {
				const bytes = CryptoJS.Rabbit.decrypt(encryptedText, email);
				return bytes.toString(CryptoJS.enc.Utf8);
			} catch (error) {
				console.error("Error decrypting value", error);
			}
		} else {
			return encryptedText;
		}
	}
	return null;
}

export {
	clearLocalStorage,
	handleB2CLogout,
	saveB2CToken,
	saveB2CEmail,
	saveDashToken,
	saveAutoLoginToken,
	saveAutoLogin,
	loadB2CToken,
	loadB2CEmail,
	loadDashToken,
	loadAutoLoginToken,
	loadAutoLogin,
	logout,
};
